import React from 'react'
import WithSubtitle from './WithSubtitle'
import Text from '../formatting/Text'

export default function DoubleTableHead ({ children, title = null, className = '' }) {
  return (
    <WithSubtitle
      className={className} subtitle={(
        <Text color='black' weight='medium' size='xs' uppercase className='pt-1' block>
          {children}
        </Text>
    )}
    >
      <Text color='primary' weight='medium' size='xs' uppercase>
        {title || ''}
      </Text>
    </WithSubtitle>
  )
}
